import { SnackbarOrigin } from '@material-ui/core'
import { ReactNode } from 'react'
import { Notification } from 'core/notifications/notificationReducers'

export enum MessageTypes {
  success = 'success',
  warning = 'warning',
  error = 'error',
  info = 'info',
}

export interface MessageOptions {
  id: string
  text: string
  variant: MessageTypes
  isOpen: boolean
  onClose: () => void
  timeout?: number
  align?: SnackbarOrigin
}

export interface BannerContentOptions {
  id: string
  content: ReactNode
  dismissable: boolean
  onClose: () => void
}

export interface INotificationsSelector extends Notification {
  isClusterError: boolean
  k8sResource: string
  k8sResourceName: string
  managementApi: string
  namespace: string
  responseData: any
  responseConfig: any
  rawNotification: any
  cluster: any
}
